export const emptyOption = {
  value: '',
  label: '',
};
